import React, { useState } from "react";
import { ModalChiTiet } from "./ModalChiTiet";

export const BtnChiTiet = ({ item }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (
        <>
            <span className="profile_name  word-break ">
                <a
                    className="blue btn-link"
                    onClick={e => { e.preventDefault(); handleShow(); }}
                >
                    {item.WorkCode}
                </a>
            </span>
            {show && (
                <ModalChiTiet
                    show={show}
                    onHide={handleClose}
                    item={item}
                />
            )}
        </>
    );
};
